import { render, staticRenderFns } from "./PortfolioHome.vue?vue&type=template&id=545d882e&scoped=true&"
import script from "./PortfolioHome.vue?vue&type=script&lang=js&"
export * from "./PortfolioHome.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHome.vue?vue&type=style&index=0&id=545d882e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d882e",
  null
  
)

export default component.exports